import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic, clientPublicService } from 'helper/axios'
import { encodeIds } from 'helper/sqids';
let resError = ''

export const getResultRoleList = async ({ token }) => {
  try {
    return await clientPublic
      .get(`role?limit=1000`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getResultBU = async ({ token }) => {
  try {
    return await clientPublic
      .get(`businessunit?limit=1000`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getResultAccountList = async ({ token, page, params }) => {
  try {
    return await clientPublic
      .post(`account/search?limit=10&page=${page}&orderby=id|asc`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const addAccount = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('account', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        resError = response
        const Error = get(response, 'data', '')
        // console.log('API ERROR +>', Error)
        return Error
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const editAccount = async ({ params, token }) => {
  try {
    return await clientPublic
      .put(`account/${params.id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const editAccountV2 = async ({id, params, token }) => {
  try {
    return await clientPublicService
      .put(`/core/management/account/${encodeIds(id)}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return {
          status: response.status,
          data: response.data.result,
          error: false,
        }
      })
      .catch((error) => {
        const { response } = error

        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }

        return {
          status: response.status,
          data: response.data,
          error: true,
        }
      })
  } catch (error) {
    console.error('error', error)

    return {
      ...resError,
      error: true,
    }
  }
}

export const getAccountByIdV2 = async ({ id, token }) => {
  try {
    return await clientPublicService
      .get(`/core/management/account/${encodeIds(id)}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return {
          status: response.status,
          data: response.data.result,
          error: false,
        }
      })
      .catch((error) => {
        const { response } = error

        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }

        return {
          status: response.status,
          data: response.data,
          error: true,
        }
      })
  } catch (error) {
    console.error('error', error)

    return {
      ...resError,
      error: true,
    }
  }
}

export const updateCompanyLink = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`company/link`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

// export const getCompanyLink = async ({ token, id }) => {
//   try {
//     return await clientPublic
//       .get(`company/link?account=${id}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         return response
//       })
//       .catch((error) => {
//         const { response } = error
//         if ([401, 403].includes(response.status)) {
//           return handleError(response)
//         }
//         return response
//       })
//   } catch (error) {
//     console.error('error', error)
//     return error
//   }
// }

export const getCompanyLink = async ({ token, id }) => {
  try {
    return await clientPublicService
      .get(`/core/account/company/link?account=${id}&status=all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const getCompanyWithLink = async ({ token }) => {
  try {
    return await clientPublic
      .get(`company/withlink`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const getCompanyWithLinkV2 = async ({ token, status, accountId }) => {
  try {
    const response = await clientPublicService.get(
      `/core/company/account_link`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          ...(status ? { status } : {}),
          ...(accountId ? { id: encodeIds(accountId) } : {}),
        },
      }
    )
    return {
      status: response.status,
      data: response.data?.result,
      error: false,
    }
  } catch (error) {
    const response = error?.response

    if (response && [401, 403].includes(response.status)) {
      return handleError(response)
    }

    return {
      status: response?.status || 500,
      data: null,
      error: true,
    }
  }
}
export const changePassword = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('account/chgpass', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        resError = response
        const Error = get(response, 'data', '')
        // console.log('API ERROR +>', Error)
        return Error
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const deleteAccount = async ({ id, token }) => {
  try {
    return await clientPublic
      .delete(`account/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const saveImageAccount = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('account/image', params, {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const deleteImageAccount = async ({ params, token }) => {
  try {
    return await clientPublic
      .delete(`account/image/${params.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const checkImportAccount = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('account/data/check', params, {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const importAccount = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('account/data/import', params, {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const exportAccount = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('account/data/export', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const accountUnLock = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`account/unlock/${params.id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const getDataPowerBI = async ({ token }) => {
  try {
    return await clientPublic
      .get(`powerbi?page=1&limit=10000`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getDataPowerBIList = async ({ token, id }) => {
  try {
    return await clientPublic
      .get(`powerbi/report/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const savePowerBI = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`powerbi/mapping`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const getResultBUV2 = async ({ token }) => {
  try {
    return await clientPublicService
      .get(`/core/management/business-group`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
